export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-3440x1440-52bb3d754e5495538d080c2d8e0f736b.jpg";